import React from 'react'
import "../Styles/Tour_information.css"
import { NavLink, Outlet } from 'react-router-dom'

function Tour_information() {
  return (
    <div className='tourInfo_container'>
      <h2 className='tourInfo_title'>Tour Information</h2>
      <div className='tourInfo_card'>
        <div className='tourInfo_section_navber' style={{overflowX:"auto"}}>
          <NavLink to={"/profile/tour-info"} end className={({ isActive }) => 
              isActive ? "tourInfo_link active" : "tourInfo_link" 
            }>
            Pending Tour
          </NavLink>
          <NavLink to={"/profile/tour-info/past"} className={({ isActive }) =>
              isActive ? "tourInfo_link active" : "tourInfo_link"
            }>
            Past Tour
          </NavLink>
          <NavLink to={"/profile/tour-info/bookedmarked"} className={({ isActive }) =>
              isActive ? "tourInfo_link active" : "tourInfo_link"
            }>
            Bookmarked Tour
          </NavLink>
          {/* <NavLink to={"/profile/tour-info/reviews"} className={({ isActive }) =>
              isActive ? "tourInfo_link active" : "tourInfo_link"
            }>
            Reviews
          </NavLink> */}
        </div>
        <hr/>
        {/* tour info content */}
        <div>
          <Outlet/>
        </div>
        </div>
    </div>
  )
}

export default Tour_information